/* eslint-disable import/order */
import { TypedUseSelectorHook, useDispatch, useSelector, shallowEqual } from 'react-redux'
import { AnyAction, configureStore, Reducer } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query'
import { connectRouter, routerMiddleware, RouterState } from 'connected-react-router'
import { createBrowserHistory, History } from 'history'
import { createLogger } from 'redux-logger'

// legacy redux declaration
import app from 'redux/app'
import bulkUpload from 'redux/bulkUpload'
import bulkUploadV2 from 'redux/bulkUploadV2'
import cloudKitchen from 'redux/cloudKitchen'
import productVendor from 'redux/productVendor'
import productVendorAdd from 'redux/productVendorAdd'
import externalDriver from 'redux/externalDriver'
import loyaltyActivity from 'redux/loyaltyActivity'
import loyaltyEarnCoin from 'redux/loyaltyEarnCoin'
import loyaltyExchangeCoin from 'redux/loyaltyExchangeCoin'
import loyaltyHistoryCoin from 'redux/loyaltyHistoryCoin'
// import product from 'redux/product'
import directPutaway from 'redux/directPutaway'
import printArea from 'redux/printArea'
import supplyOrderAddProductDirect from 'redux/supplyOrderAddProductDirect'
import supplyOrderCheckQty from 'redux/supplyOrderCheckQty'
import campaignAddManual from 'redux/campaignAddManual'
import supplyOrderApproval from 'redux/supplyOrderApproval'
import allOrder from 'redux/allOrder'
import addEditVoucher from 'redux/addEditVoucher'
import orderPooling from 'redux/orderPooling'
// import uniqueVoucherList from 'redux/uniqueVoucherList'
// import uniqueVoucherCampaignList from 'redux/uniqueVoucherCampaignList'
// import uniqueVoucherPromoAddAndEdit from 'redux/uniqueVoucherPromoAddAndEdit'
import fraudSetting from 'redux/fraudSetting'
import blackAndWhiteList from 'redux/blackAndWhiteList'
import supplyOrderPicking from 'redux/supplyOrderPicking'
import stockOpnameList from 'redux/stockOpname/list'
import stockOpnameCheckAdjustment from 'redux/stockOpname/checkAdjustment'
import stockOpnameAdd from 'redux/stockOpname/add'
import constant from 'redux/constant'
import loadingGoods from 'redux/loadingGoods'
import promoPwp from 'redux/promoPwp'
// import banner from 'redux/banner'
import koliLost from 'redux/koliLost'
import filterLocationLists from 'redux/filterLocationLists'
import editPooling from 'redux/editPooling'
import referralMissionList from 'redux/referralMission/list'
import referralMissionAddAndEdit from 'redux/referralMission/addAndEdit'
import flagManagement from 'redux/flagManagement'
import campaign from 'redux/campaign'
import category from 'redux/category'
import catalogue from 'redux/catalogue'
import orderDetail from 'redux/orderDetail'
import fraudReferral from 'redux/fraudReferral'
import fraudWatchTowerRule from 'redux/fraudWatchTowerRule'
import fraudWatchTowerQueryRule from 'redux/fraudWatcTowerQueryRule'
import fraudWatchTowerParameters from 'redux/fraudWatchTowerParameters'
import changeTimeslot from 'redux/changeTimeslot'
import gwp from 'redux/gwp'
import promotionList from 'redux/promotion/list'
import campaignSegment from 'redux/campaignSegment'
import productAssortment from 'redux/productAssortment'
import productTanggungRenteng from 'redux/productTanggungRenteng'
import tanggungRenteng from 'redux/tanggungRenteng'
import productLabel from 'redux/productLabel'
import abAdminCreateEdit from 'redux/abAdmin/abAdminCreateEdit'
import abAdminList from 'redux/abAdmin/abAdminList'
import allOrderV2 from 'features/Order/redux/AllOrder'
import campaignLoyaltyList from 'redux/loyalty/campaignLoyaltyList'
import campaignLoyaltyAddAndEdit from 'redux/loyalty/campaignLoyaltyAddAndEdit'
import campaignLoyaltyProductAddManual from 'redux/loyalty/campaignLoyaltyProductAddManual'
import { fullfilmentApi } from './services/api'
import order from './pages/Order/redux/order'
import packer from './pages/Order/redux/packer'
import referralVIPList from './pages/ReferralVIP/GetList/redux'
import dynamicLandingList from 'redux/dynamicLandingList'
import dynamicLanding from 'redux/dynamicLanding'
// --------- Legacy redux declaration ///

// new redux declaration //
import * as AuthFeatures from 'features/Auth/redux'
import * as AccountFeatures from 'features/Account/redux'
import * as CampaignAndDiscountFeatures from 'features/CampaignAndDiscount/redux'
import * as LoyaltyFeatures from 'features/Loyalty/redux'
import * as SupplyOrderFeatures from 'features/SupplyOrder/redux'
import * as FraudFeatures from 'features/Fraud/redux'
import * as LocationFeatures from 'features/Location/redux'
import * as AstroEventFeatures from 'features/AstroEvent/redux'
import * as ProductFeatures from 'features/Product/redux'
import * as PaymentFeatures from 'features/Payment/redux'
import * as PromotionFeatures from 'features/Promotion/redux'
import * as OrderFeatures from 'features/Order/redux'
import * as HRISFeatures from 'features/Enterprise/HRIS/redux'
import * as ReorderListFeatures from 'features/Enterprise/ReorderList/redux'
import * as CapacityHandlerFeatures from 'features/Enterprise/CapacityHandler/redux'
import * as SKPFeatures from 'features/Enterprise/SKP/redux'
import * as CategoryAndPosisiFeatures from 'features/CategoryAndPosisi/redux'
import * as HCUFeatures from 'features/HCU/redux'
import * as RackFeatures from 'features/Rack/redux'
import * as BannerAndTickerFeatures from 'features/BannerAndTicker/redux'
import * as VendorsFeatures from 'features/Enterprise/Vendor/redux'
import * as SOAutomationFeatures from 'features/Enterprise/SOAutomation/redux'
import * as ABAdmin from 'features/ABAdmin/redux'
import * as SchedulesFeatures from 'features/Enterprise/Schedules/redux'
import * as HRISAccountFeatures from 'features/Enterprise/Account/redux'
import * as PricingEngineFeatures from 'features/PricingEngine/redux'
import * as AssetManagementFeatures from 'features/AssetManagement/redux'
import * as PayrollFeatures from 'features/Enterprise/Payroll/redux'
import * as DynamicPricing from 'features/DynamicPricing/redux'
import * as MasterAreaPickingFeatures from 'features/MasterAreaPicking/redux'
import * as PurchaseOrderFeatures from 'features/PurchaseOrder/redux'
import * as MidmileFeatures from 'features/Midmile/redux'
import * as SegmentationFeatures from 'features/Segmentation/redux'
import * as SCMSFeatures from 'features/SCMS/redux'
import * as AdsManagementFeatures from 'features/AdsManagement/redux'
import * as ApprovalEngine from 'features/ApprovalEngine/redux'
import * as MultiCategoryFeatures from 'features/MultiCategory/redux'
// new redux declaration //

export const createStore = (history: History) => {
  const loggerMiddleware = () => {
    const logger = createLogger({ collapsed: true })
    if (process.env.NODE_ENV !== 'production') {
      return logger
    }
    return [] as unknown as typeof logger
  }

  return configureStore({
    reducer: {
      router: connectRouter(history) as Reducer<RouterState, AnyAction>,
      app,
      bulkUpload,
      bulkUploadV2,
      filterLocationLists,
      productVendor,
      productVendorAdd,
      cloudKitchen,
      // product,
      externalDriver,
      directPutaway,
      loyaltyEarnCoin,
      loyaltyExchangeCoin,
      loyaltyHistoryCoin,
      loyaltyActivity,
      printArea,
      supplyOrderAddProductDirect,
      supplyOrderCheckQty,
      campaignAddManual,
      supplyOrderApproval,
      allOrder,
      addEditVoucher,
      orderPooling,
      // uniqueVoucherList,
      // uniqueVoucherCampaignList,
      // uniqueVoucherPromoAddAndEdit,
      fraudSetting,
      blackAndWhiteList,
      supplyOrderPicking,
      stockOpnameList,
      stockOpnameCheckAdjustment,
      stockOpnameAdd,
      constant,
      loadingGoods,
      promoPwp,
      // banner,
      // timeSlot,
      // loadingDock,
      // inboundSchedule,
      // inboundScheduleAdd,
      koliLost,
      referralMissionList,
      referralMissionAddAndEdit,
      flagManagement,
      campaign,
      category,
      catalogue,
      orderDetail,
      fraudReferral,
      fraudWatchTowerRule,
      fraudWatchTowerQueryRule,
      fraudWatchTowerParameters,
      gwp,
      promotionList,
      productTanggungRenteng,
      tanggungRenteng,
      editPooling,
      changeTimeslot,
      order,
      packer,
      campaignSegment,
      productAssortment,
      productLabel,
      abAdminCreateEdit,
      campaignLoyaltyList,
      campaignLoyaltyAddAndEdit,
      campaignLoyaltyProductAddManual,
      referralVIPList,
      dynamicLanding,
      dynamicLandingList,
      [fullfilmentApi.reducerPath]: fullfilmentApi.reducer,
      abAdminList,
      allOrderV2,
      ...AuthFeatures,
      ...AstroEventFeatures,
      ...CampaignAndDiscountFeatures,
      ...AccountFeatures,
      ...LoyaltyFeatures,
      ...SupplyOrderFeatures,
      ...FraudFeatures,
      ...LocationFeatures,
      ...ProductFeatures,
      ...OrderFeatures,
      ...PaymentFeatures,
      ...PromotionFeatures,
      ...HRISFeatures,
      ...ReorderListFeatures,
      ...CapacityHandlerFeatures,
      ...SKPFeatures,
      ...CategoryAndPosisiFeatures,
      ...HCUFeatures,
      ...RackFeatures,
      ...BannerAndTickerFeatures,
      ...VendorsFeatures,
      ...SOAutomationFeatures,
      ...ABAdmin,
      ...SchedulesFeatures,
      ...HRISAccountFeatures,
      ...PricingEngineFeatures,
      ...AssetManagementFeatures,
      ...PayrollFeatures,
      ...DynamicPricing,
      ...MasterAreaPickingFeatures,
      ...PurchaseOrderFeatures,
      ...MidmileFeatures,
      ...SegmentationFeatures,
      ...SCMSFeatures,
      ...AdsManagementFeatures,
      ...ApprovalEngine,
      ...MultiCategoryFeatures,
    },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: false,
      })
        .concat(fullfilmentApi.middleware)
        .concat(routerMiddleware(history))
        // @ts-expect-error: loggerMiddleware legacy typing - do not remove
        .concat(loggerMiddleware()),
  })
}

export const history = createBrowserHistory()
export const store = createStore(history)

export type AppDispatchType = typeof store.dispatch
export type RootStateType = ReturnType<typeof store.getState>

export const useAppSelector: TypedUseSelectorHook<RootStateType> = useSelector
export const useAppDispatch: () => AppDispatchType = useDispatch
export { shallowEqual }

setupListeners(store.dispatch)
